<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <v-row>

          <v-row>
          <v-col cols="12">
            <v-sheet tile height="54" class="d-flex">
              <!-- <v-select
                v-model="Department"
                :items="DepartmentItem"
                dense
                outlined
                hide-details
                label="แผนก"
                class="ma-2"
              ></v-select> -->
              <v-select
                v-model="day"
                :items="dayName"
                dense
                outlined
                hide-details
                label="วัน"
                class="ma-2"
              ></v-select>
              <!-- เดือน -->
              <v-select
                v-model="month"
                :items="monthNameTH"
                dense
                outlined
                hide-details
                label="เดือน"
                class="ma-2"
              ></v-select>
              <!-- ปี -->
              <v-select
                v-model="year"
                :items="yearsNumber"
                dense
                outlined
                hide-details
                label="ปี"
                class="ma-2"
              ></v-select>
              <!-- ค้นหา -->
              <v-icon
                color="#871B12"
                size="30"
                @click="getData()"
                >mdi-calendar-search</v-icon
              >
            </v-sheet>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="pa-5 ma-2">
            <v-btn
              :loading="!dataReady"
              :disabled="!dataReady"
              color="blue-grey"
              class="white--text"
              @click="exportData()"
            >
              Download
              <v-icon right dark> mdi-cloud-download </v-icon>
            </v-btn>
            <v-btn
              :loading="!dataReady"
              :disabled="!dataReady"
              color="blue-grey"
              class="white--text"
              @click="getData()"
            >
              reload
              <v-icon right dark> mdi-reload </v-icon>
            </v-btn>
          </v-col>
        </v-row>

          <!-- รายละเอียด -->
        <v-dialog v-model="dialog" persistent max-width="80%">
          <v-card>
            <v-card-title>
              <span class="headline">ตรวจสอบข้อมูล</span>
            </v-card-title>
            <v-card-text>
              <v-card>
                <v-row>
                  <v-col>
                    <div class="text-h5 mb-4">*ข้อมูลพนักงาน</div>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #1b437c">
                            <th class="text-left">ข้อมูล</th>
                            <th class="text-left">รายละเอียด</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>รหัสพนักงาน</td>
                            <td>{{ dateItemInfo.empCode }}</td>
                          </tr>
                          <tr>
                            <td>ชื่อ นามสกุล</td>
                            <td>{{ dateItemInfo.empFull_NameTH }}</td>
                          </tr>
                          <tr>
                            <td>แผนก</td>
                            <td>{{ dateItemInfo.masDepartmentName }}</td>
                          </tr>
                          <tr>
                            <td>สาขา</td>
                            <td>{{ dateItemInfo.masBranchName }}</td>
                          </tr>
                          <tr>
                            <td>บริษัท</td>
                            <td>{{ dateItemInfo.masCompanyName }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                  <v-col>
                    <div class="text-h5 mb-4">*ข้อมูลการขอสวัสดิการ</div>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #1b437c">
                            <th class="text-left">ข้อมูล</th>
                            <th class="text-left">รายละเอียด</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr>
                            <td>หัวข้อการอบรม</td>
                            <td>{{ dateItemInfo.Training_topics }}</td>
                          </tr>
                          <tr>
                            <td>ชื่อวิทยากรผู้สอน</td>
                            <td>{{ dateItemInfo.Training_trainer }}</td>
                          </tr>
                           <tr>
                            <td>วันที่เข้ารับการอบรม</td>
                            <!-- <td>{{ dateItemInfo.Training_startDate }}</td> -->
                            <td><v-combobox
                                    v-model="dateItemInfo.Training_startDate"
                                    multiple
                                    chips
                                    small-chips
                                    readonly
                                  ></v-combobox></td>
                           </tr>
                           <tr>
                            <td>จำนวนวัน</td>
                            <td>{{ dateItemInfo.training_count }}</td>
                           </tr>
                           <tr>
                            <td>ช่วงเวลาอบรม</td>
                            <td>{{ dateItemInfo.Training_duration }}</td>
                          </tr>
                           <tr>
                            <td>สถานที่อบรม</td>
                            <td v-if="dateItemInfo.Training_location !='อื่นๆ'">{{ dateItemInfo.Training_location }}</td>
                            <td v-if="dateItemInfo.Training_location =='อื่นๆ'">{{ dateItemInfo.Training_other }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
                <v-col>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #1b437c">
                            <th class="text-left">ข้อมูล</th>
                            <th class="text-left">รายละเอียด</th>
                          </tr>
                        </thead>

                        <tbody>
                           <tr>
                            <td>วัตถุประสงค์ หรือ เป้าหมายในเรื่องที่เข้าอบรม</td>
                            <td>{{dateItemInfo.Training_objective}}</td>
                          </tr>
                           <tr>
                            <td>สรุปเกี่ยวกับเรื่องที่ท่านเข้าอบรม</td>
                            <td>{{dateItemInfo.Training_conclusion}}</td>
                          </tr>
                           <tr>
                            <td>ท่านคิดว่าการอบรมจะมีประโยชน์ต่อการปฏิบัติงานของท่าน
                      และองค์กรของท่านอย่างไร</td>
                            <td>{{dateItemInfo.Training_benefit}}</td>
                          </tr>
                           <tr>
                            <td>ความคิดเห็นเพิ่มเติม</td>
                            <td>{{dateItemInfo.Training_comment}}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
              </v-card>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                elevation="2"
                x-large
                color="dark darken-1"
                text
                @click="dialog = false"
              >
                <v-icon left> mdi-minus-box-outline</v-icon>
                ปิด
              </v-btn>
              <v-btn
                elevation="2"
                x-large
                color="success"
                text
                @click="dialog = false"
              >
                <v-icon left> mdi-check-circle-outline</v-icon>
                อนุมัติ
              </v-btn>
              <v-btn
                elevation="2"
                x-large
                color="red"
                text
                @click="dialog = false"
              >
                <v-icon left> mdi-cancel</v-icon>
                ไม่อนุมัติ
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- end รายละเอียด -->

        <!-- รายละเอียด -->
        <v-dialog v-model="dialogView" persistent max-width="80%">
          <v-card>
            <v-card-title>
              <span class="headline">ตรวจสอบข้อมูล</span>
            </v-card-title>
            <v-card-text>
              <v-card>
                <v-row>
                  <v-col>
                    <div class="text-h5 mb-4">*ข้อมูลพนักงาน</div>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #1b437c">
                            <th class="text-left">ข้อมูล</th>
                            <th class="text-left">รายละเอียด</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>รหัสพนักงาน</td>
                            <td>{{ dateItemInfo.empCode }}</td>
                          </tr>
                          <tr>
                            <td>ชื่อ นามสกุล</td>
                            <td>{{ dateItemInfo.empFull_NameTH }}</td>
                          </tr>
                          <tr>
                            <td>แผนก</td>
                            <td>{{ dateItemInfo.masDepartmentName }}</td>
                          </tr>
                          <tr>
                            <td>สาขา</td>
                            <td>{{ dateItemInfo.masBranchName }}</td>
                          </tr>
                          <tr>
                            <td>บริษัท</td>
                            <td>{{ dateItemInfo.masCompanyName }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                  <v-col>
                    <div class="text-h5 mb-4">*ข้อมูลการขอสวัสดิการ</div>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #1b437c">
                            <th class="text-left">ข้อมูล</th>
                            <th class="text-left">รายละเอียด</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>จำนวนวัน</td>
                            <td>{{ dateItemInfo.welfareRequest }}</td>
                          </tr>
                          <tr>
                            <td>สถานะ</td>
                            <td v-if="dateItemInfo.welfare_status == 'confirm'">รอ ผู้จัดการแผนกทรัพยากรบุคคล อนุมัติ</td>
                          </tr>
                          <tr>
                            <td>ไฟล์แนบ</td>
                          </tr>
                          <tr>
                            <td>1</td>
                            <td>
                              <a
                                :href="dateItemInfo.welfareFile"
                                target="_blank"
                                download
                                v-if="dateItemInfo.welfareFile"
                              >
                                <b>[File Download]</b>
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>
                              <a
                                :href="dateItemInfo.welfareFile2"
                                target="_blank"
                                download
                                v-if="dateItemInfo.welfareFile2"
                              >
                                <b>[File Download]</b>
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>
                              <a
                                :href="dateItemInfo.welfareFile3"
                                target="_blank"
                                download
                                v-if="dateItemInfo.welfareFile3"
                              >
                                <b>[File Download]</b>
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td>
                              <a
                                :href="dateItemInfo.welfareFile4"
                                target="_blank"
                                download
                                v-if="dateItemInfo.welfareFile4"
                              >
                                <b>[File Download]</b>
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td>5</td>
                            <td>
                              <a
                                :href="dateItemInfo.welfareFile5"
                                target="_blank"
                                download
                                v-if="dateItemInfo.welfareFile5"
                              >
                                <b>[File Download]</b>
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </v-card>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                elevation="2"
                x-large
                color="dark darken-1"
                text
                @click="dialogView = false"
              >
                <v-icon left> mdi-minus-box-outline</v-icon>
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- end รายละเอียด -->

          <!-- data table -->
          <v-col cols="12">
          <v-alert dense type="info" icon="mdi-file-account">
            รายการ <strong>อนุมัติ</strong>
          </v-alert>
          <v-card elevation="7" v-if="dataReady">
            <v-card-text>
              <v-text-field
                v-model="searchAll"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
              <v-data-table
                :headers="columns"
                :items="dataItem"
                :search="searchAll"
                :items-per-page="10"
              >
                <template v-slot:[`item.action`]="{ item }">
                  <v-btn
                    color="info"
                    @click="getDataById(item), (dialog = true)"
                  >
                    ตรวจสอบ
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <div v-if="!dataReady" class="text-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import dayName from '../../../assets/master/Date/day.json'
import monthNameTH from '../../../assets/master/Date/monthNameTH.json'
import yearsNumber from '../../../assets/master/Date/yearsNumber.json'
import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile
  },
  created () {
    setInterval(this.getNowGlobal, 1000)
  },
  data () {
    return {
      PK: '',
      path: '/welfare/', // Path Model
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'แบบสอบถาม',
          disabled: true,
          href: '/Master/welfareRequest'
        }
      ],
      // End Menu Config
      dataReady: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      // Dialog Config ADD EDIT DELETE
      dialog: false,
      dialogView: false,
      // END Dialog Config ADD EDIT DELETE
      session: this.$session.getAll(),
      // Search All
      searchAll: '',
      searchAll1: '',
      // Data Table Config
      columns: [
        { text: 'ID', value: 'TrainingID' },
        { text: 'สวัสดิการ', value: 'TrainingCode' },
        { text: 'รหัสพนักงาน', value: 'empCode' },
        { text: 'พนักงาน', value: 'empFull_NameTH' },
        { text: 'ตำแหน่ง', value: 'positionName' },
        { text: 'แผนก', value: 'masDepartmentName' },
        { text: 'สาขา', value: 'masBranchName' },
        { text: 'วันที่ทำรายการ', value: 'training_date' },
        { text: 'Action', value: 'action', sortable: false, align: 'center' }
      ],
      dataItem: [],
      dateItemInfo: [],
      // End Data Table Config
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ],
      // End Export Config
      BranchItem: [], // สาขา
      DepartmentItem: [], // แผนก
      CompanyItem: [], // บริษัท
      Company: '', // บริษัท
      Branch: '', // บริษัท
      Department: '', // บริษัท
      year: '',
      month: '',
      day: '',
      dayName: dayName,
      monthNameTH: monthNameTH,
      yearsNumber: yearsNumber,
      profileHR: []
    }
  },
  async mounted () {
    this.month = this.getMonthTh()
    let date = new Date()
    this.year = moment().format('YYYY')
    // this.month = date.getMonth() + 1
    this.day = date.getDate()
    await this.getData()

    // await this.getDataCompany()
    // await this.getDataBranch()
    // await this.getDataDepartment()
  },
  methods: {
    async getData () {
      await this.getDataWaiting()
    },
    async getDataWaiting () {
      this.dataItem = []

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/quest_assessment/get'
        )
        .then(async (response) => {
          this.dataReady = true
          this.dataItem = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
    },
    async getDataById (item) {
      console.log('ITEMS', item)
      this.dateItemInfo = []
      this.dateItemInfo = item
      this.dateItemInfo.Training_startDate = JSON.parse(this.dateItemInfo.Training_startDate)
      console.log('this.dateItemInfo.Training_startDate', this.dateItemInfo.Training_startDate)
    },
    async approve (item, status) {
      this.dataReady = false
      var statusName =
        status === 'confirm'
          ? 'อนุมัติ'
          : status === 'cancel'
            ? 'ไม่อนุมัติ'
            : 'ยกเลิก'
      this.$swal({
        title: 'ท่านต้องการ ' + statusName + ' ใช่หรือไม่',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          this.dataReady = false
          let ds = {
            welfareID: item.welfareID,
            welfare_status: status,
            welfareAmount: item.welfareAmount,
            LAST_USER: this.session.data.userName
          }
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + "/welfare/update",
              ds,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              this.$swal('เรียบร้อย', 'ส่งข้อมูลเรียบร้อย', 'success')
              await this.getData()
              this.dataReady = true
            })
        })
        .catch((error) => {
          this.dataReady = false
          this.getData()
          console.log(error)
        })
    },
    // บริษัท
    async getDataCompany () {
      this.CompanyItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_company/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masCompanyName
            s.value = d.masCompanyName
            d = s
            this.CompanyItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    // สาขา
    async getDataBranch () {
      this.BranchItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_branch/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masBranchName
            s.value = d.masBranchName
            d = s
            this.BranchItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    // แผนก
    async getDataDepartment () {
      this.DepartmentItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_department/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masDepartmentName
            s.value = d.masDepartmentName
            d = s
            this.DepartmentItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },

    // training_date,
    // training_day,
    // training_month,
    // training_year,
    // Training_topics,
    // Training_trainer,
    // Training_startDate,
    // Training_endDate,
    // Training_duration,
    // Training_location,
    // Training_other,
    // Training_objective,
    // Training_conclusion,
    // Training_benefit,
    // Training_comment,
    // training_assess1,
    // training_assess2,
    // training_assess3,
    // training_assess4,
    // training_assess5,
    // training_assess6,
    // training_assess7,
    // training_assess8,
    async exportData () {
      var tem1 = []
      this.dataItem.forEach((element) => {
        let s = {
          'รหัสพนักงาน': element.empCode,
          'ชื่อพนักงาน': element.empFull_NameTH,
          'แผนก': element.masDepartmentName,
          'สาขา': element.masBranchName,
          'บริษัท': element.masCompanyName,
          'เบอร์โทร': element.empTel,
          'สวัสดิการ': element.TrainingCode,
          'ปี': element.training_year,
          'เดือน': element.training_month,
          'วัน': element.training_day,
          'หัวข้อการอบรม': element.Training_topics,
          'ชื่อวิทยากรผู้สอน': element.Training_trainer,
          'วันที่เข้ารับการอบรม': element.Training_startDate,
          'จำนวนวัน': element.training_count,
          'ช่วงเวลาอบรม': element.Training_duration,
          'สถานที่อบรม': element.Training_location,
          'วัตถุประสงค์': element.Training_objective,
          'สรุป': element.Training_conclusion,
          'ประโยชน์': element.Training_benefit,
          '1.สถานที่จัดฝึกอบรมมีคุณภาพ': element.training_assess1,
          '2.การให้ข้อมูลด้านความรู้เสริมทักษะในการไปปฏิบัติงาน': element.training_assess2,
          '3.อุปกรณ์ เครื่องมือ ประกอบการใช้ฝึกอบรม': element.training_assess3,
          '4.วิทยากรมีเทคนิคการถ่ายทอดที่ดี': element.training_assess4,
          '5.วิทยากรสามารถกระตุ้นให้เกิดความสนใจในเนื้อหา': element.training_assess5,
          '6.การใช้เวลาเหมาะสมกับเรื่องการฝึกอบรม': element.training_assess6,
          '7.ท่านได้รับการเอาใจใส่ในการฝึกอบรมจากศูนย์ฝึกอบรมเป็นอย่างดี': element.training_assess7,
          '8.โดยภาพรวมการฝึกอบรมครั้งนี้': element.training_assess8,
          'ความคิดเห็นเพิ่มเติม': element.Training_comment
        }
        tem1.push(s)
      })
      var data = XLSX.utils.json_to_sheet(tem1)
      var wb = XLSX.utils.book_new() // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb, data, 'รออนุมัติ') // sheetAName is name of Worksheet
      this.month = this.getMonthTh()
      let date = new Date()
      this.year = moment().format('YYYY')
      this.day = date.getDate()
      XLSX.writeFile(wb, 'แบบสอบถาม(' + this.day + ' ' + this.month + ' ' + this.year + ').xls') // name of the file is 'book.xlsx'
    }
  }
}
</script>
<style scope>
.v-data-table-header {
  background-color: #1b437c !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/Welfare/WelfareManageQuest.vue